/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AccountCountSummary { 
    /**
     * Number of accounts in ABANDONED state.
     */
    abandoned: number;
    /**
     * Number of accounts in ASSIGNED state.
     */
    assigned: number;
    /**
     * Number of accounts in ONBOARDED state.
     */
    onboarded: number;
    /**
     * Number of accounts in READY state.
     */
    ready: number;
    /**
     * Number of accounts in TOMBSTONED state.
     */
    tombstoned: number;
    /**
     * Total number of accounts.
     */
    total: number;
}

